import { TYPE } from '../actions/types'

export default function (state = {}, action) {
    switch (action.type) {
        case TYPE.GET_HOTEL_ROOMS:
            return { ...state, response: action.payload }
        case TYPE.UPDATE_HOTEL_ROOMS:
            return { ...state, response: action.payload }
        default:
            return state;
    }
}

